<h2 mat-dialog-title>{{data.title}}</h2>

<mat-dialog-content class="mat-typography mb-4">
  <h3 style="font-weight: bold">{{data.detail}}</h3>
  <div *ngFor="let message of data.message">
    <span>{{message}}</span><br>
  </div>
  <div style="margin-top: 1rem;" *ngIf="data.useImage">
    <span style="font-weight: bold">Exemplo</span>
    <div style="display: flex; width: 100%; justify-content: center;">
      <img [src]="data.image" style="max-width: 80%" alt="Imagem de confirmação" />
    </div>
  </div>
  <div *ngIf="data.download">
    <a [href]="data.download" download>Clique para baixar o modelo</a>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button [mat-dialog-close]="true" mat-button cdkFocusInitial>Confirmar</button>
  <button mat-button mat-dialog-close>Cancelar</button>
</mat-dialog-actions>
